import Vue from 'vue'

import {
  AtomAce,
  AtomButton,
  AtomCheckBox,
  AtomCheckBox2,
  AtomCheckBox3,
  AtomChip,
  AtomChipButton,
  AtomChipFill,
  AtomErrorTooltip,
  AtomIconBar,
  AtomIconBook,
  AtomIconBookOpen,
  AtomIconCalendar,
  AtomIconDisc,
  AtomIconFile,
  AtomIconHelp,
  AtomIconRemove,
  AtomImage,
  AtomInputText,
  AtomLabel,
  AtomLabelRequired,
  AtomLabelTori,
  AtomLink,
  AtomLinkButton,
  AtomLoading,
  AtomOverlay,
  AtomRadioButton,
  AtomRadioButton2,
  AtomReadingNumber,
  AtomSelect,
  AtomSystemCodeAreaSelect,
  AtomSystemParameterSelect,
  AtomTextArea,
  AtomTextField
} from '@/components/atoms'
import { ModalAlert } from '@/components/modals/ModalAlert'
import { ModalShelfDiagram } from '@/components/modals/ModalShelfDiagram'
import { ModalBibliographyDetailReal } from '@/components/modals/ModalBibliographyDetailReal'
import { ModalBibliographyDetailSet } from '@/components/modals/ModalBibliographyDetailSet'
import { ModalBibliographySearchCondition } from '@/components/modals/ModalBibliographySearchCondition'
import { ModalBibliographySearchHistory } from '@/components/modals/ModalBibliographySearchHistory'
import { ModalBibliographySearchResult } from '@/components/modals/ModalBibliographySearchResult'
import { ModalBibliographySearchResultAuthority } from '@/components/modals/ModalBibliographySearchResultAuthority'
import { ModalBibliographySearchResultContent } from '@/components/modals/ModalBibliographySearchResultContent'
import { ModalCode } from '@/components/modals/ModalCode'
import { ModalCodeKey } from '@/components/modals/ModalCodeKey'
import { ModalCollectionEdit } from '@/components/modals/ModalCollectionEdit'
import { ModalError } from '@/components/modals/ModalError'
import { ModalForwardingRequest } from '@/components/modals/ModalForwardingRequest'
import { ModalJobList } from '@/components/modals/ModalJobList'
import { ModalOrderEdit } from '@/components/modals/ModalOrderEdit'
import { ModalQuickMenu } from '@/components/modals/ModalQuickMenu'
import { ModalReturnHistory } from '@/components/modals/ModalReturnHistory'
import { ModalUpdateCollectionMemo } from '@/components/modals/ModalUpdateCollectionMemo'
import { ModalUpdateOrderMemo } from '@/components/modals/ModalUpdateOrderMemo'
import { ModalUserDetail } from '@/components/modals/ModalUserDetail'
import { ModalUserSearch } from '@/components/modals/ModalUserSearch'
import { ModalBibliographyTagDataEdit } from '@/components/modals/ModalBibliographyTagDataEdit'
import { ModalCollectionSelect } from '@/components/modals/ModalCollectionSelect'
import { ModalProcessPlaceChange } from '@/components/modals/ModalProcessPlaceChange'
import { ModalReceiptHistory } from '@/components/modals/ModalReceiptHistory'
import { ModalReturnCheckAlert } from '@/components/modals/ModalReturnCheckAlert'

Vue.component('AtomAce', AtomAce)
Vue.component('AtomButton', AtomButton)
Vue.component('AtomCheckBox', AtomCheckBox)
Vue.component('AtomCheckBox2', AtomCheckBox2)
Vue.component('AtomCheckBox3', AtomCheckBox3)
Vue.component('AtomChip', AtomChip)
Vue.component('AtomChipButton', AtomChipButton)
Vue.component('AtomChipFill', AtomChipFill)
Vue.component('AtomErrorToolTip', AtomErrorTooltip)
Vue.component('AtomIconBar', AtomIconBar)
Vue.component('AtomIconBook', AtomIconBook)
Vue.component('AtomIconBookOpen', AtomIconBookOpen)
Vue.component('AtomIconCalendar', AtomIconCalendar)
Vue.component('AtomIconDisc', AtomIconDisc)
Vue.component('AtomIconFile', AtomIconFile)
Vue.component('AtomIconHelp', AtomIconHelp)
Vue.component('AtomIconRemove', AtomIconRemove)
Vue.component('AtomImage', AtomImage)
Vue.component('AtomInputText', AtomInputText)
Vue.component('AtomLabel', AtomLabel)
Vue.component('AtomLabelRequired', AtomLabelRequired)
Vue.component('AtomLabelTori', AtomLabelTori)
Vue.component('AtomLink', AtomLink)
Vue.component('AtomLinkButton', AtomLinkButton)
Vue.component('AtomLoading', AtomLoading)
Vue.component('AtomOverlay', AtomOverlay)
Vue.component('AtomRadioButton', AtomRadioButton)
Vue.component('AtomRadioButton2', AtomRadioButton2)
Vue.component('AtomReadingNumber', AtomReadingNumber)
Vue.component('AtomSelect', AtomSelect)
Vue.component('AtomSystemParameterSelect', AtomSystemParameterSelect)
Vue.component('AtomTextArea', AtomTextArea)
Vue.component('AtomTextField', AtomTextField)
Vue.component('AtomSystemCodeAreaSelect', AtomSystemCodeAreaSelect)
Vue.component('ModalAlert', ModalAlert)
Vue.component('ModalReturnCheckAlert', ModalReturnCheckAlert)
Vue.component('ModalShelfDiagram', ModalShelfDiagram)
Vue.component('ModalBibliographyDetailReal', ModalBibliographyDetailReal)
Vue.component('ModalBibliographyDetailSet', ModalBibliographyDetailSet)
Vue.component(
  'ModalBibliographySearchCondition',
  ModalBibliographySearchCondition
)
Vue.component('ModalBibliographySearchHistory', ModalBibliographySearchHistory)
Vue.component('ModalBibliographySearchResult', ModalBibliographySearchResult)
Vue.component(
  'ModalBibliographySearchResultAuthority',
  ModalBibliographySearchResultAuthority
)
Vue.component(
  'ModalBibliographySearchResultContent',
  ModalBibliographySearchResultContent
)
Vue.component('ModalBibliographyTagDataEdit', ModalBibliographyTagDataEdit)
Vue.component('ModalCode', ModalCode)
Vue.component('ModalCodeKey', ModalCodeKey)
Vue.component('ModalCollectionEdit', ModalCollectionEdit)
Vue.component('ModalError', ModalError)
Vue.component('ModalForwardingRequest', ModalForwardingRequest)
Vue.component('ModalJobList', ModalJobList)
Vue.component('ModalOrderEdit', ModalOrderEdit)
Vue.component('ModalQuickMenu', ModalQuickMenu)
Vue.component('ModalReturnHistory', ModalReturnHistory)
Vue.component('ModalUpdateCollectionMemo', ModalUpdateCollectionMemo)
Vue.component('ModalUpdateOrderMemo', ModalUpdateOrderMemo)
Vue.component('ModalUserDetail', ModalUserDetail)
Vue.component('ModalUserSearch', ModalUserSearch)
Vue.component('ModalCollectionSelect', ModalCollectionSelect)
Vue.component('ModalProcessPlaceChange', ModalProcessPlaceChange)
Vue.component('ModalReceiptHistory', ModalReceiptHistory)
// import _ from 'lodash'
//
// const components = require.context(
//   '@/components/global',
//   false,
//   /[A-Z]\w+\.(vue)$/
// )
// _.forEach(components.keys(), fileName => {
//   const componentConfig = components(fileName)
//   const componentName = fileName
//     .split('/')
//     .pop()
//     .split('.')[0]
//   Vue.component(componentName, componentConfig.default || componentConfig)
// })
